<template>
  <el-dialog
    width="560px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visibleDialog"
    append-to-body
  >
    <div class="dialog-wrap">
      <div class="tip-content">
        <pre>
        1、名单里的商家能推过爆版强制鉴权环节。
        2、导入后替换原本的商家名单。
        3、导入的格式为：从A2~A无限，一个单元格一个商家ID。
        </pre>
      </div>

      <div class="button-wrap">
        <el-upload
          style="margin-right: 12px"
          :action="importAuthWhiteApi"
          :show-file-list="false"
          :auto-upload="true"
          :on-success="importAuthWhiteSuccess"
          with-credentials
        >
          <el-button type="primary" size="mini" icon="el-icon-top">
            导入白名单
          </el-button>
        </el-upload>

        <el-button
          type="success"
          size="mini"
          icon="el-icon-bottom"
          @click="handleExportAuthWhite"
        >
          导出白名单
        </el-button>
      </div>
    </div>

    <!-- <div slot="footer">
      <el-button @click="isShowBatchBindFollowerDialog = false">取消</el-button>
      <el-button type="primary" @click="handleBatchBindFollower">
        确定
      </el-button> -->
    <!-- </div> -->
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "AuthWhiteDialog",
  data() {
    return {
      visibleDialog: false,
      importAuthWhiteApi: `${apiBaseURL}/erp/SupplyDimensionConfig/importAuthWhiteSupplyIds`,
    };
  },

  methods: {
    // 显示弹框
    showDialog() {
      this.visibleDialog = true;
    },
    // 成功导入
    importAuthWhiteSuccess(data) {
      if (data.code !== 200) {
        this.$message.e(data.msg);
      } else {
        this.visibleDialog = false;
        this.$message.success("导入成功");
      }
    },
    // 导出白名单
    handleExportAuthWhite() {
      this.$post("/erp/SupplyDimensionConfig/exportAuthWhiteSupplyIds").then(
        (rs) => {
          this.visibleDialog = false;
          window.open(apiBaseURL + rs.file);
        }
      );
    },
  },
};
</script>

<style scoped>
.dialog-wrap {
  position: relative;
}
.dialog-wrap .button-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 0px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/AuthWhiteDialog.vue